/**
 * Calendar Error Component
 * 
 * Display error message with retry button when calendar fails to load
 */

import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface CalendarErrorProps {
  error?: any;
  onRetry?: () => void;
}

export const CalendarError: React.FC<CalendarErrorProps> = ({ error, onRetry }) => {
  const errorMessage = error?.data?.detail || error?.error || 'Failed to load calendar';

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12">
      <div className="text-center max-w-md mx-auto">
        {/* Error Icon */}
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-red-100 rounded-full">
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
        </div>

        {/* Error Message */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Failed to Load Calendar
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          {errorMessage}
        </p>

        {/* Retry Button */}
        {onRetry && (
          <button
            onClick={onRetry}
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Retry
          </button>
        )}

        {/* Help Text */}
        <div className="mt-6 text-xs text-gray-500">
          If the problem persists, please contact support or check your network connection.
        </div>
      </div>
    </div>
  );
};

